import React from 'react';

import { getRoot } from 'mobx-easy';
import { Driver, Run } from '@bringg/types';
import { observer } from 'mobx-react';

import useTimeFormat from 'bringg-web/hooks/use-time-format';
import { Date } from '../../../../../components';
import { DetailedCellProps } from '../hooks/use-columns';
import { routesMonitoringRootStore } from '../../stores/routes-monitoring-root-store';
import RootStore from 'bringg-web/stores/root-store';

const getEtaBase = (route: Run, isRealtimeEtaEnabled: boolean, driver?: Driver) => {
	if (!route.started_at || route.ended_at) {
		return undefined;
	}

	if (isRealtimeEtaEnabled && driver?.eta_to_home) {
		return driver.eta_to_home;
	}

	return route.scheduled_end_time;
};

export const getEtaToHome = (routeId: number): string => {
	const { driversStore, runStore } = getRoot<RootStore>().data;
	const {
		routeMonitoringTimelineViewStore: { isRealtimeEtaEnabled }
	} = routesMonitoringRootStore.getStore();

	const route = runStore.get(routeId);

	if (!route) {
		return '';
	}

	return getEtaBase(route, isRealtimeEtaEnabled, driversStore.get(route.user_id));
};

const EtaBaseCell = ({ row }: DetailedCellProps) => {
	const etaToHome = getEtaToHome(row.data.id);
	const timeFormat = useTimeFormat();

	return <Date format={timeFormat} date={etaToHome} />;
};

export default observer(EtaBaseCell);
